export default __webpack_public_path__ + "static/media/background-1.47387bd4.png";